import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  deletePayPalMerchantAccount,
  DeletePayPalMerchantAccountPayload,
} from 'api/admin/businesses/deletePayPalMerchantAccount';

export const useDeletePayPalMerchantAccount = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, DeletePayPalMerchantAccountPayload>({
    mutationFn: async ({ businessId, paypalMerchantAccountId }) => {
      return deletePayPalMerchantAccount({ businessId, paypalMerchantAccountId });
    },
    onSuccess: async () => {
      toaster('PayPal Merchant Account has been removed', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(
        error?.response?.data?.error ?? 'An error occurred while removing PayPal merchant account',
        {
          icon: '❌',
        },
      );
      return error;
    },
  });
};
